import { render, staticRenderFns } from "./LoggedOutSidebar.vue?vue&type=template&id=bbd1ac7c&scoped=true&"
import script from "./LoggedOutSidebar.vue?vue&type=script&lang=js&"
export * from "./LoggedOutSidebar.vue?vue&type=script&lang=js&"
import style0 from "./LoggedOutSidebar.vue?vue&type=style&index=0&id=bbd1ac7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd1ac7c",
  null
  
)

export default component.exports